import React, { useEffect, useState } from 'react'
import Input from '../../../../../components/Form/Input'
import Select from '../../../../../components/Form/Select'
import TextAreaEditor from '../../../../../components/Form/TextAreaEditor'
// import ButtonHoverAnimated from "../../../../../components/Buttons/ButtonHoverAnimated"
// import DropdownCheckbox from "../../../../../../components/Dropdown/DropdownCheckbox"
import ImagePicker from '../../../../../components/ImagePicker'
import Notification from '../../../../../components/Notification'
import axios from "axios"
import ButtonBlack from '../../../../../components/Buttons/ButtonBlack'
import { api, PATH_END_POINT } from '../../../../../../api'
import { useSelector } from 'react-redux'
import { TRAINING_API_END_POINT } from '../../../../../utils/constant'
import { useNavigate, useParams } from 'react-router-dom'

const Edit = () => {
    const { id } = useParams();
    const navigate = useNavigate()
  const [formData, setFormData] = useState({
    trainer_id: "",
    image: null,
    title: "",
    type: "",
    method_training: "",
    description: "",
    duration: "",
    hadCertification: 0,
    hadDiploma: 0,
    fees: "",
    required_profile: "",
    reference: "",
    objective: "",
    training_start_at: "",
    training_end_at: "",
    registration_start_at: "",
    registration_end_at: "",
    location: "",
  });
  const {user} = useSelector((state)=>state.user)
  const [errors, setErrors] = useState({})
  const [touchedFields, setTouchedFields] = useState({})
  const [loading, setLoading] = useState(false)
  const [showNotif, setShowNotif] = useState({
    show: false,
    message:"Une erreur est survenue!",
    variant: "danger"
  })

 useEffect(() => {
    const fetchTraining = async () => {
      try {
        const response = await axios.get(`${TRAINING_API_END_POINT}/detail/${id}`);
        console.log("Données reçues :", response.data); // Vérifiez ici
        setFormData((prevValues) => ({ ...prevValues, ...response.data }));
        // setFormValues2(response.data);
        // console.log("Form Values mis à jour :", formValues, formValues2);
      } catch (error) {
        console.error("Erreur lors de la récupération de l'offre :", error);
      }
    };

    fetchTraining();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prevValues) => ({ ...prevValues, [name]: value }))
    if (value.trim() !== "") {
      setErrors({
        ...errors,
        [name]: "",
      });
    }
  }

  const handleTextFieldChange = (name, value) => {
    // const { name, value } = e.target
    setFormData((prevValues) => ({ ...prevValues, [name]: value }))
    if (value.trim() !== "") {
      setErrors({
        ...errors,
        [name]: "",
      });
    }
  }

  // (value) => 

  const handleFocus = (e) => {
    const { name } = e.target;
    setTouchedFields({
      ...touchedFields,
      [name]: true,
    });
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    if (touchedFields[name] && value.trim() === "") {
      setErrors({
        ...errors,
        [name]: "Ce champ est requis.",
      });
    }
  }

  const handleImageChange = (event) => {
    const file = event.target.files[0]; // Récupérer le fichier
    if (file) {
        setFormData((prevValues) => ({ ...prevValues, image: file }));
    }
};

  const validateForm = () => {
    let newErrors = {};

    if (!formData.title.trim()) newErrors.title = "Le titre de la formation est requis.";
    if (!formData.type) newErrors.type = "Veuillez sélectionner un type de formation.";
    if (!formData.method_training) newErrors.method_training = "Veuillez sélectionner un mode d'enseignement.";
    if (!formData.duration) newErrors.duration = "La durée de formation est requis.";
    if (!formData.category) newErrors.category = "Veuillez sélectionner une catégorie.";
    if (!formData.training_end_at) newErrors.training_end_at = "Veuillez sélectionner une date d'expiration.";
    if (!formData.location.trim()) newErrors.location = "L'adresse est requise.";
    if (!formData.description.trim()) newErrors.description = "La description est requise.";
    if (!formData.objective.trim()) newErrors.objective = "Le programme est requis.";
    // if (!formData.image) newErrors.image = "Une image est requise.";

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});
    setLoading(true);

    if (!validateForm()) {
      setLoading(false);
      return;
    }

    // try {
      const formDataToSend = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        formDataToSend.append(key, value);
      });

      console.log("Data submitted", formData)

      await axios.post(api+"/training/"+user?.id+"/update/"+ formData?.id, formDataToSend, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response)=>{
        console.log(response.data)
        // alert("Formation ajoutée avec succès !");
        if(response.data?.training){
          setShowNotif({...showNotif, variant: "success", message:response?.data?.message, show: true})
          setTimeout(() => {
            navigate("/mira-formateur/formation/"+id+"/inscription/1")
          }, 3000)
        }else{
          setShowNotif({...showNotif, variant: "danger", message:"Une erreur est survenue", show: true})
        }
     
      })    
    .catch((err)=> {
      setShowNotif({...showNotif, variant: "danger", message:"Une erreur est survenue", show: true})
      console.log("Échec de l'enregistrement. Vérifiez les champs.", err);
    } )
    .finally (()=>{
      setLoading(false);
    })
  }


  return (
    <div className="min-h-full w-full pr-6 lg:pr-20 xl:pr-40 pl-6 text-primary-black py-6 ">
      <h2 className="text-2xl font-bold mb-4">Ajouter une formation</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <Input label="Titre de formation" name="title" value={formData.title} onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur} error={errors.title} />
        <Select label="Type de formation" name="type" options={[ "","Cours Normal", "Cours Acceleré", "Cours Avancé"]} value={formData.type} onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur} error={errors.type} />
        <Select label="Mode d'enseignement" name="method_training" options={["Présentiel", "A distance", "En alternance"]} value={formData.method_training} onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur} error={errors.mode} />
        <Input label="Durée de formation" name="duration" value={formData.duration} onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur} error={errors.title} />
        <Select label="Catégorie" name="category" options={["CDI", "CDD"]} value={formData.category} onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur} error={errors.category} />
        <Input label="Date d'expiration" type="date" name="training_end_at" value={formData.training_end_at?.split(" ")[0]} onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur} error={errors.training_end_at} />
        <ImagePicker label="Image" name="image"  initialImage={formData?.image ? PATH_END_POINT + formData?.image : ""} handleImage={handleImageChange} error={errors.image} />

        <h3 className="font-semibold text-start mb-4">Localisation</h3>
        <Input label="Adresse" name="location" value={formData.location} onChange={handleChange} onFocus={handleFocus} onBlur={handleBlur} error={errors.location} />

        <TextAreaEditor label="Description" name="description" value={formData.description} setValue={(value)=>handleTextFieldChange('description', value)} error={errors.description} />
        <TextAreaEditor label="Programme" name="objective" value={formData.objective} setValue={(value)=>handleTextFieldChange('objective', value)}  error={errors.objective} />

        <ButtonBlack isLoading={loading} onClick={handleSubmit} type="submit">
          Modifier la formation
        </ButtonBlack>
      </form>
      <Notification variant={showNotif.variant} isOpen={showNotif.show} setIsOpen={()=>setShowNotif({...showNotif, show: false})} text={showNotif.message}/>
    </div>
  );
};

// export default PostTraining;

export default Edit